<template>
    <div>
        <label class="label">Transmissions</label>
        <div class="field is-grouped is-grouped-multiline">
            <div class="control" v-for="(name, index) in names" :key="index">
                <label class="checkbox">
                    <input type="checkbox"
                           :checked="checkTransmission(name)"
                           @click="handleTransmission(name)" />
                    {{ name }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                names: ['AT', 'MT', 'OTHER']
            }
        },
        methods: {
            checkTransmission: function (transmission) {
                return this.$store.getters.getQueryTransmissionStatus(transmission)
            },
            handleTransmission: function (transmission) {
                this.$store.dispatch('handleQueryTransmission', transmission)
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Specification/TransmissionsSpecification.vue